export enum DeletionTypeEnum {
    plan = 1,
    administrator,
    memberPlan,
    verificationField,
    document
}
